module.exports = __webpack_public_path__ + "img/gem8_color5.84fe52fa.png";